import React from "react";
import useDataLoader from "../../hooks/useDataLoader2";
import CatalogTitle from "../../components/Moleculas/Catalog Text/CatalogTitle";
import BackgroundComponent from "../../components/Layout/BackgroundProfile/BackgroundProfile";
import ProfileViewModeBg from "../../assets/images&icons/profileViewMode.jpeg";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import { ColumnConfig } from "../../interfaces/Catalogs/ColumnExport.tsx/ColumnExport";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import Eye2 from "../../components/Atomos/Icons/Eye";
import { formatTimeSpanToString } from "../../utils/functions";
import { defaultPageSize } from "../../utils/const";
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import { accessOptions } from "../../Enums";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const ActivityLog: React.FC = ({ ...props }) => {
  const {firmData} = UseFirmList();
  const endpoint = '/activityLog';
  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    inputFilters,
    setInputFilters,
    filter
  } = useDataLoader<any>({
    endpoint,
    defaultPageSize,
    persistentFilter: {
      page: {
      value: "Catalogs",
      comparisonType: "CONTAINS",
    }}
  });

  const columnsDef = React.useMemo(() => [
    { 
      id: "count", 
      header: "#", 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {rowIndex + 1 + pagination.pageIndex * pagination.pageSize}
        </p>
      )
    },
    { id: "personName", header: "User" },
    { id: "firmName", header: "Firm" },
    { id: "accessType", header: "Access Type" },
    { id: "action", header: "Action" },
    { id: "page", header: "Page" },
    {
      id: "_ts",
      header: "Created Date",
      cell: ({ value }: { rowIndex: number; row: any; value: any }) => {
        return value
          ? new Date(Number(value) * 1000).toLocaleDateString("en-GB", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
            })
          : "";
      },
    },
    {
      id: "details",
      header: "Details",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <React.Fragment>
          <PersistentLink
            to={`details/${row.id}`}
            state={{
              state: JSON.parse(row.resourceUpdated),
              actionPerformed: row.action,
            }}
            className="flex gap-[.625rem] whitespace-nowrap items-center"
            persistingData={{
              pagination,
              sort,
              filter, 
              inputFilters, 
            }}
          >
            View Log Details
            <div className="editsvg">
              <Eye2 />
            </div>
          </PersistentLink>
        </React.Fragment>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const filtersData: IFilterData[] = React.useMemo(() => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Firm",
        fieldName: "memberFirms",
        objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
      },
      {
        name: "Access",
        fieldName: "memberFirms",
        objectData: accessOptions || [],
      },
      {
        name: "Published Date",
        fieldName: "publishedDate",
        type: "date",
        comparison: "BETWEEN",
      },
    ], [firmData]);

  return (
    <>
      <BackgroundComponent image={ProfileViewModeBg} />
        <div className="flex flex-col gap-5 lg:gap-6 lg:pb-[1.125rem] pb-5">
          <CatalogTitle
            title={`Catalogs Activity Log`}
            className="text-white !pb-0"
          />
          <hr className="flex h-0 justify-center items-center self-stretch relative z-10" />
          <div className="flex w-full">
          </div>
        </div>
        <CatalogTableC
          noNewCatalog
          catalogName={"Activity Log"}
          route={"activityLog"}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default ActivityLog;
